module.exports = __webpack_public_path__ + "media/assets/images/flags/gi-65641450457e943419c3a18b6d9c7da8.svg";